export default function PlatformShowcase() {
  const platforms = [
    {
      name: 'Control4',
      description: 'Industry-leading smart home automation with seamless integration across lighting, climate, entertainment, and security systems.',
      logo: 'https://public.readdy.ai/ai/img_res/c89865c071f60434af10e626c86e3d57.jpg',
      icon: 'ri-home-gear-line',
      color: 'from-[#4A90E2] to-[#357ABD]',
      features: ['Whole-home automation', 'Voice control integration', 'Custom programming', 'Remote access']
    },
    {
      name: 'Savant',
      description: 'Luxury automation platform delivering unparalleled control and elegant user experiences for high-end residential projects.',
      logo: 'https://readdy.ai/api/search-image?query=Savant%20smart%20home%20luxury%20automation%20official%20company%20logo%20on%20clean%20white%20background%20professional%20brand%20identity%20high%20resolution%20corporate%20branding&width=200&height=80&seq=savantlogo001&orientation=landscape',
      icon: 'ri-smartphone-line',
      color: 'from-[#5A9FD4] to-[#4A90E2]',
      features: ['Premium interface design', 'Apple ecosystem integration', 'Scene automation', 'Energy management']
    },
    {
      name: 'RTI',
      description: 'Professional-grade control systems offering robust performance and flexibility for complex automation requirements.',
      logo: 'https://readdy.ai/api/search-image?query=RTI%20Remote%20Technologies%20Incorporated%20control%20systems%20official%20company%20logo%20on%20clean%20white%20background%20professional%20brand%20identity%20high%20resolution%20corporate%20branding&width=200&height=80&seq=rtilogo001&orientation=landscape',
      icon: 'ri-remote-control-line',
      color: 'from-[#357ABD] to-[#2A5F8F]',
      features: ['Custom UI design', 'Multi-room control', 'Third-party integration', 'Scalable architecture']
    },
    {
      name: 'Brilliant',
      description: 'Modern smart home control with intuitive touchscreen switches that blend seamlessly into contemporary interiors.',
      logo: 'https://readdy.ai/api/search-image?query=Brilliant%20smart%20home%20control%20touchscreen%20switches%20official%20company%20logo%20on%20clean%20white%20background%20professional%20brand%20identity%20high%20resolution%20corporate%20branding&width=200&height=80&seq=brilliantlogo001&orientation=landscape',
      icon: 'ri-lightbulb-flash-line',
      color: 'from-[#6BB6E8] to-[#4A90E2]',
      features: ['Touch panel controls', 'Built-in Alexa', 'Video intercom', 'Motion sensing']
    }
  ];

  return (
    <section id="platforms" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A90E2] mb-4 font-light">
            AUTOMATION PLATFORMS
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            <strong>Premium Control Systems</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We specialize in the industry's most advanced <strong>home automation platforms</strong>, delivering tailored solutions for luxury residences in <strong>South East Florida</strong> and <strong>Tampa</strong>
          </p>
        </div>

        {/* Platform Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {platforms.map((platform, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-2xl hover:border-[#4A90E2]/30 transition-all duration-300"
            >
              {/* Logo */}
              <div className="mb-6 h-20 flex items-center">
                <img 
                  src={platform.logo} 
                  alt={`${platform.name} logo`}
                  className="h-16 w-auto object-contain"
                />
              </div>

              {/* Content */}
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                {platform.name}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                {platform.description}
              </p>

              {/* Features */}
              <ul className="space-y-3 mb-6">
                {platform.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#4A90E2]/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#4A90E2] text-xs"></i>
                    </div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <a
                href={`#${platform.name.toLowerCase()}`}
                className="inline-flex items-center gap-2 text-sm font-medium text-[#4A90E2] hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Not sure which platform is right for your project?
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#4A90E2] text-white text-sm font-medium tracking-wide rounded-full hover:bg-[#3A7BC8] hover:shadow-lg hover:shadow-[#4A90E2]/30 transition-all cursor-pointer whitespace-nowrap"
          >
            Schedule a Consultation
            <i className="ri-calendar-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
